<template>
  <header>
    <div
      class="container-fluid d-flex py-1 align-items-center"
      v-bind:class="{'px-lg-3 px-lg-5 px-3 py-3':$route.name!='menuIndex'||user.id}"
    >
      <div
        v-bind:class="{'d-none d-sm-flex':$route.name=='menuIndex','d-flex':$route.name!='menuIndex'}"
        class="logo  align-items-center"
      >
        <router-link
          class="text-black"
          :to="{ name: 'home' }"
        ><img
            src="/storage/images/logo.svg"
            class="site-header-logo"
          /></router-link>
      </div>
      <div class="ml-auto small d-none d-lg-flex align-items-center">
        <navigation
          v-on:close-nav="closeNav"
          :isInline="true"
        ></navigation>
      </div>
      <div
        v-if="!user.id&&($route.name=='home')"
        class="ml-auto small font-weight-bold d-flex align-items-center"
      >
        <router-link
          class="d-flex mr-2 text-black"
          :to="{ name: 'logIn' }"
        >Login</router-link>
        <router-link
          class="btn btn-sm btn-primary"
          :to="{ name: 'signUp' }"
        >Sign Up</router-link>
      </div>
      <div
        class=" mobile-nav"
        :class="{'open':navOpen}"
      >
        <div
          v-on:mousedown="closeNav"
          class="placeholder"
        >
        </div>
        <div class="contents pt-5">
          <button
            class=" btn color-1 p-1 nav-close"
            role="button"
            aria-label="Close"
            v-on:click="closeNav"
          ><i class="fal fa-times"></i></button>
          <navigation
            v-on:close-nav="closeNav"
            :isInline="false"
          ></navigation>
        </div>
      </div>

      <div
        v-if="user.id"
        class="text-right ml-auto d-lg-none"
      >
        <button
          class=" btn color-1 p-2 nav-open"
          v-on:click="openNav"
        ><i class="fal fa-bars"></i></button>
      </div>
    </div>
    <systemMessageNotification v-if="user.id"></systemMessageNotification>
    <notification v-if="showNotification"></notification>

  </header>
</template>

<style scoped>
</style>

<script>
import navigation from "../../components/shared/navigation";
import systemMessageNotification from "../../components/notification/SystemMessage";
import notification from "../../components/notification/General";

export default {
  mounted() {
    this.enableBodyScroll();
  },
  data() {
    return {
      navOpen: false,
    };
  },
  methods: {
    openNav() {
      this.disableBodyScroll();
      this.navOpen = true;
    },
    closeNav() {
      this.enableBodyScroll();
      this.navOpen = false;
    },
  },
  components: {
    navigation,
    notification,
    systemMessageNotification,
  },
};
</script>
